
    var riot = require('riot')
    
riot.tag2('site-logo', '<a class="site-logo" href="/"> <div class="site-logo-svg"></div><span>滋賀県観光情報 - 滋賀の観光をもっと楽しく!</span></a>', '', '', function(opts) {
    const self = this
    self.on('mount', () => {
      $('.site-logo-svg').load('/design/img/cmn/logo.svg')
    })
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/site-logo.tag